"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-veneto": {
    "1caba76f": [{
      "hkey": "e493d7bc",
      "slug": "boschetti",
      "name": "Boschetti",
      "primary": true,
      "skipSearch": false
    }],
    "boschetta": [{
      "hkey": "e493d7bc",
      "slug": "boschetti",
      "name": "Boschetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "11cbab6f": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "buli": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "023f94d4": [{
      "hkey": "57733180",
      "slug": "santa-margherita-d-adige",
      "name": "Santa Margherita d'Adige",
      "primary": true,
      "skipSearch": false
    }],
    "centri-santa-margherita-d-adige": [{
      "hkey": "57733180",
      "slug": "santa-margherita-d-adige",
      "name": "Santa Margherita d'Adige",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "borgo-veneto"
    }],
    "21c5bfcf": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "granze": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2b12a17": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "mucini": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "695588f0": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "p-i-p": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3babe949": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "pernechele": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be74828a": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "stona": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbe959b0": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "vasco": [{
      "hkey": "878cdeef",
      "slug": "borgo-veneto",
      "name": "Borgo Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;